export enum CommandCenterJobType {
  BLOCKED = 'blocked',
  COMPLETED = 'completed',
  MAJOR_HAZARD = 'majorHazard',
  LIVE = 'live',
}
